import { isObject } from 'src/utils/is-object';

export function isPromise(value: unknown): value is Promise<unknown> {
  return isObject(value) && typeof value.then === 'function';
}
